import { BASE_URL } from './Config.js';

export class ProductService {
  createProduct = async (productData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/product/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(productData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la création');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error creating product:', error); throw error; }
  };

  getAllProducts = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/product/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch products');
      return await response.json();
    } catch (error) { console.error('Error fetching products:', error); throw error; }
  };

  getProductById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/product/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch product');
      return await response.json();
    } catch (error) { console.error('Error fetching product:', error); throw error; }
  };

  updateProduct = async (id, productData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/product/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(productData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la mise à jour');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error updating product:', error); throw error; }
  };

  deleteProduct = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/product/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to delete product');
      return true;
    } catch (error) { console.error('Error deleting product:', error); throw error; }
  };

      deleteAllProducts = async () => {
    const token = localStorage.getItem('accessToken');
    const res = await fetch(`${BASE_URL}/product/delete-all`, {
      method: 'DELETE',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    });
    
    if (!res.ok) {
      // En cas d'erreur, on lit le texte brut car le serveur peut renvoyer une erreur HTML/Texte
      const errText = await res.text(); 
      throw new Error(errText || 'Erreur lors de la suppression globale');
    }
    
    //  c'est du vrai JSON, donc res.json() fonctionne parfaitement
    return await res.json(); 
  };

  searchProducts = async (query) => {
  const token = localStorage.getItem('accessToken');
  
  const res = await fetch(`${BASE_URL}/product/search?query=${encodeURIComponent(query)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    throw new Error('Erreur lors de la recherche de produits');
  }

  return await res.json();
};
}